module.exports = __webpack_public_path__ + "static/media/stripe.9d9112e7.svg";